
export const PublicDeliverySellerOne = new TypedDocumentString(`
    query PublicDeliverySellerOne($input: InputPublicDeliverySeller!, $id: InputId!) {
  publicDeliverySellerOne(input: $input, id: $id) {
    id
    items {
      type
      all
      mainland
      zoneTitle
      prices {
        weightUi
        price
        __typename
      }
      __typename
    }
    __typename
  }
}
    `, {"hash":"39638b6c3de4382b4f474286f34b32123e5415289c6ea9220a85d6212fb695cc"});